// Servicio de QR dinámico
import { apiClient } from './api';
import { API_BASE_URL } from '../config';

export const dynamicQrService = {
  /**
   * Consultar estado del QR dinámico (solo consulta, NO genera)
   * @returns {Promise<Object>} Estado de la sesión QR o null si no hay QR activo
   */
  async getStatus() {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/api/client/dynamic-qr`);
      return response;
    } catch (error) {
      console.error('Error consultando estado de QR:', error);
      throw error;
    }
  },

  /**
   * Generar un nuevo QR dinámico para el cliente autenticado
   * @returns {Promise<Object>} Datos de la sesión QR generada
   */
  async generate() {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/api/client/dynamic-qr/generate`);
      return response;
    } catch (error) {
      console.error('Error generando QR dinámico:', error);
      throw error;
    }
  },

  /**
   * Marcar QR como expirado
   * @param {string} token - Token del QR
   * @returns {Promise<Object>} Confirmación
   */
  async expire(token) {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/api/client/dynamic-qr/expire`, {
        token,
      });
      return response;
    } catch (error) {
      console.error('Error expirando QR:', error);
      throw error;
    }
  },
};

// Servicio para escaneo en tienda (público)
export const storeQrService = {
  /**
   * Validar un código QR escaneado
   * @param {string} token - Token del QR
   * @param {number} storeId - ID de la tienda
   * @returns {Promise<Object>} Resultado de validación
   */
  async validate(token, storeId) {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/api/store/dynamic-qr/validate`, {
        token,
        store_id: storeId,
      });
      return response;
    } catch (error) {
      console.error('Error validando QR:', error);
      throw error;
    }
  },

  /**
   * Redimir un código QR (aplicar beneficio)
   * @param {string} token - Token del QR
   * @param {number} storeId - ID de la tienda
   * @param {number} benefitId - ID del beneficio
   * @param {string} ticketNumber - Número de ticket
   * @param {string} scannerName - Nombre de la persona que escanea
   * @returns {Promise<Object>} Confirmación
   */
  async redeem(token, storeId, benefitId, ticketNumber, scannerName) {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/api/store/dynamic-qr/redeem`, {
        token,
        store_id: storeId,
        benefit_id: benefitId,
        ticket_number: ticketNumber,
        scanner_name: scannerName,
      });
      return response;
    } catch (error) {
      console.error('Error redimiendo QR:', error);
      throw error;
    }
  },
};

